/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { createContext, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getSettingsView } from '../settings';
import { getAggregations } from '../../services/aggregations';

export const GridViewContext = createContext(null);

export const GridViewProvider = ({ children, commonProps }) => {

  const gridViewInstance: any = useRef(null);
  const { t } = useTranslation();

  const [gridEditData, setGridEditData] = useState(null);
  const [currentWorkspaceUuid, setCurrentWorkspaceUuid] = useState(null);

  const globalKeyEvent = useSelector((state: any) => state.globalKeyEvent);
  const workspaces = useSelector((state: any) => state.workspaces.instances);
    
  const timeFormat = JSON.parse(localStorage.getItem('timeFormat'));
  const dateFormat = JSON.parse(localStorage.getItem('dateFormat'));

  const settings = getSettingsView(commonProps.navData);
  const aggregations = getAggregations(commonProps.navData);
  

  return (
    <GridViewContext.Provider
      value={{
        gridViewInstance,
        gridEditData,
        setGridEditData,
        globalKeyEvent,
        currentWorkspaceUuid,
        setCurrentWorkspaceUuid,
        workspaces,
        t,
        timeFormat,
        dateFormat,
        settings,
        aggregations,
        ...commonProps
      }}
    >
      {children}
    </GridViewContext.Provider>
  );
};

GridViewProvider.propTypes = {
  children: PropTypes.node.isRequired,
  commonProps: PropTypes.object
};
